import { StreamActions } from '@hotwired/turbo';

StreamActions.dismiss_sidebar = function () {
  const location = new URL(window.location);

  if (location.searchParams.has('sidebar')) {
    window.history.back();
  }
};
